import { BRAND_COLOR_TOKENS } from './designTokens';

export const CHART_SERIES_COLORS = [
  BRAND_COLOR_TOKENS.primary,
  '#2C7C93',
  '#B44A79',
  '#A9761C',
  '#2E8B6B',
  '#4457C4',
] as const;

export const CHART_ROLE_COLORS = {
  axis: BRAND_COLOR_TOKENS.muted,
  grid: BRAND_COLOR_TOKENS.border,
  surface: BRAND_COLOR_TOKENS.white,
  tooltipBorder: BRAND_COLOR_TOKENS.border,
  tooltipLabel: BRAND_COLOR_TOKENS.indigo,
  tooltipText: BRAND_COLOR_TOKENS.muted,
} as const;

export const WORKSPACE_STATUS_COLORS: Record<string, string> = {
  active: BRAND_COLOR_TOKENS.successText,
  suspended: BRAND_COLOR_TOKENS.warningText,
};

export const WORKSPACE_TYPE_COLORS: Record<string, string> = {
  solo: BRAND_COLOR_TOKENS.primary,
  organization: BRAND_COLOR_TOKENS.violet,
};

export function resolveSeriesColor(index: number): string {
  const color = CHART_SERIES_COLORS[index % CHART_SERIES_COLORS.length];
  if (color === undefined) {
    return CHART_SERIES_COLORS[0];
  }
  return color;
}
